import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/zetta_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-02f61ef7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"table","width":"100%"} }, [
  /*#__PURE__*/_createElementVNode("b", { style: {"display":"table-cell","vertical-align":"middle","font-size":"18px"} }, " ふせん集計ツール ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalMsg = _resolveComponent("ModalMsg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.modal)
        ? (_openBlock(), _createBlock(_component_ModalMsg, { key: 0 }, {
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("div", null, [
                (_ctx.isLogin)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      type: "fill",
                      onClick: _ctx.logout
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("ログアウト")
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_Button, {
                  type: "line",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modal = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("閉じる")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]))
  ]))
}